<template>
   <el-tabs type="border-card" style="height:auto">
    <el-tab-pane label="线上订单 > 订单列表" style="height:auto" >
      <el-form :inline="true" :model="order" class="demo-form-inline">
        <div>
          <el-form-item label="订单时间" size="mini">
            <el-date-picker
              v-model="order.orderTime"
              value-format="yyyy-MM-dd"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="支付时间" size="mini">
            <el-date-picker
              v-model="order.payTime"
              value-format="yyyy-MM-dd"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="用户来源" size="mini">
            <el-select v-model.trim="order.isSource" placeholder="来源">
              <el-option label="全部" value=""></el-option>
              <el-option label="百度" value="1"></el-option>
            </el-select>
          </el-form-item>
        </div>
        <div>
        <el-form-item label="订单编号">
          <el-input size="mini" v-model.trim="order.orderNo" placeholder="订单编号"></el-input>
        </el-form-item>
        <el-form-item label="产品型号">
          <el-input size="mini" v-model.trim="order.manufacturerNumber" placeholder="产品型号"></el-input>
        </el-form-item>
        <el-form-item label="登录用户名">
          <el-input size="mini" v-model.trim="order.moblie" placeholder="登录用户名"></el-input>
        </el-form-item>
        <el-form-item label="订单状态" size="mini">
          <el-select v-model.trim="order.orderStatus" placeholder="支付渠道">
            <el-option label="全部" value=""></el-option>
            <el-option label="申请退款" value="-992"></el-option>
            <el-option label="已退款" value="-993"></el-option>
            <el-option label="已取消" value="-991"></el-option>
            <el-option label="待确认" value="990"></el-option>
            <el-option label="待付款" value="991"></el-option>
            <el-option label="部分付款" value="992"></el-option>
            <el-option label="预付付款" value="9921"></el-option>
            <el-option label="待审核" value="993"></el-option>
            <el-option label="待发货" value="994"></el-option>
            <el-option label="未付审批" value="9941"></el-option>
            <el-option label="发货中" value="995"></el-option>
            <el-option label="已发货" value="996"></el-option>
            <el-option label="未付发货" value="9961"></el-option>
            <el-option label="已完成" value="997"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="关联订单">
          <el-checkbox v-model="order.isBelong"></el-checkbox>
        </el-form-item>
        <el-form-item label="屏蔽取消">
          <el-checkbox v-model="order.isCancel"></el-checkbox>
        </el-form-item>
        <el-form-item>
          <el-button size="mini" type="primary" @click="onSubmit">查询</el-button>
        </el-form-item>
        </div>
      </el-form>
      <el-table
        :data="data"
         size="small"
        :row-class-name="tableRowClassName"
        @cell-dblclick="mainTabClick"
        :row-key="getRowKeys"
        :expand-row-keys="expands"
        @expand-change="openExpand"
        border>
        <el-table-column 
          fixed
          type="expand"
          Scoped slot>
          <template slot-scope="props">
            <el-tabs v-model="activeName" @tab-click="handleClick(props.row)" style="width:100%">
              <el-tab-pane label="订单详情" name="first">
                <el-table 
                :data="props.row.childList"
                :row-class-name="tableRowName"
                @cell-dblclick="subTabClick"
                 border style="height:100%;">
                  <el-table-column
                    fixed
                    prop="manufacturerNumber"
                    show-overflow-tooltip
                    label="产品型号"
                    width="210">
                    <template scope="scope" >
                      <span v-if="scope.row.isAdd == 1">
                        <el-select
                          v-model="scope.row.productId"
                          filterable
                          remote
                          reserve-keyword
                          placeholder="请输入产品型号"
                          :remote-method="searchProduct"
                          :loading="loading">
                          <el-option
                            v-for="item in productOtions"
                            :key="item.id"
                            :label="item.manufacturerNumber +'-'+item.platFormId"
                            :value="item.id">
                          </el-option>
                        </el-select>
                      </span>
                      <template v-else>
                        <span>{{scope.row.manufacturerNumber}}</span>
                      </template>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="brandName"
                    show-overflow-tooltip
                    label="品牌"
                    width="110">
                  </el-table-column>
                  <el-table-column
                    prop="originalPrice"
                    show-overflow-tooltip
                    label="原单价"
                    width="100">
                  </el-table-column>
                  <el-table-column
                    prop="discountedPrice"
                    show-overflow-tooltip
                    label="购买价格"
                    width="100">
                  </el-table-column>
                  <el-table-column prop="costPrice" label="成本价"
                    width="85"
                    show-overflow-tooltip>
                    <template scope="scope" >
                      <span v-if="(user.isAdmin || (!user.isAdmin && (scope.row.costPrice == 0 || scope.row.costPrice == null))) 
                      && (scope.row.orderStatus>=3 && scope.row.index === cellCost.tabCostIndex && cellCost.tabCostLabel === '成本价')">
                        <el-input size="small"
                        v-model="cellCost.price" placeholder="请输入内容" @blur="handleSubCostEdit(scope.row)"/>
                      </span>
                      <template v-else>
                        <span>{{scope.row.costPrice}}</span>
                      </template>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="count"
                    label="购买数量"
                    width="80">
                    <template scope="scope" >
                      <span v-if="scope.row.isAdd == 1">
                        <el-input v-model="scope.row.count ">
                        </el-input>
                      </span>
                      <template v-else>
                        <span>{{scope.row.count}}</span>
                      </template>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="sendCount"
                    label="已发货"
                    width="70">
                  </el-table-column>
                  <el-table-column
                    prop="attachAmount"
                    label="附加费"
                    width="80">
                  </el-table-column>
                  <el-table-column
                    prop="preferentialMargins"
                    label="总优惠"
                    width="70">
                  </el-table-column>
                  <el-table-column
                    label="状态"
                    width="84">
                    <template slot-scope="scope">
                      <span v-if="scope.row.orderStatus == -4" style="color:#989998">支付失败</span>
                      <span v-if="scope.row.orderStatus == -3" style="color:#ccc">已退款</span>
                      <span v-if="scope.row.orderStatus == -2" style="color:#989998">退款申请</span>
                      <span v-if="scope.row.orderStatus == -1" style="color:#ccc">已取消</span>
                      <span v-if="scope.row.orderStatus == 0" style="color:#F56C6C">待确认</span>
                      <span v-if="scope.row.orderStatus == 1" style="color:#F56C6C">待付款</span>
                      <span v-if="scope.row.orderStatus == 2" style="color:#E6A23C">部分付款</span>
                      <span v-if="scope.row.orderStatus == 21" style="color:#F56C6C">预付订单</span>
                      <span v-if="scope.row.orderStatus == 3" style="color:#67C23A">待审核</span>
                      <span v-if="scope.row.orderStatus == 4" style="color:#E6A23C">待发货</span>
                      <span v-if="scope.row.orderStatus == 41" style="color:#E6A23C">未付审批</span>
                      <span v-if="scope.row.orderStatus == 5" style="color:#E6A23C">发货中</span>
                      <span v-if="scope.row.orderStatus == 6" style="color:#409EFF">已发货</span>
                      <span v-if="scope.row.orderStatus == 61" style="color:#409EFF">未付发货</span>
                      <span v-if="scope.row.orderStatus == 7" style="color:#F56C6C">已完成</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="originalAmount"
                    label="原总金额"
                    width="95">
                  </el-table-column>
                  <el-table-column
                    prop="totalAmount"
                    label="总金额"
                    width="95">
                  </el-table-column>
                  <el-table-column
                    :formatter="formatStockState"
                    prop="stockState"
                    label="来源"
                    width="80">
                  </el-table-column>
                  <el-table-column prop="remark" label="备注"
                    width="150"
                    show-overflow-tooltip>
                    <template scope="scope" >
                      <span v-if="scope.row.index === cellRemark.tabSubIndex && cellRemark.tabSubLabel === '备注'">
                        <el-input size="small"
                        v-model="cellRemark.remark.sub" placeholder="请输入内容" @blur="handleSubRemarkEdit(scope.row)"/>
                      </span>
                      <template v-else>
                        <span>{{scope.row.remark}}</span>
                      </template>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="操作">
                    <template slot-scope="scope">
                      <template v-if="scope.row.isAdd">
                        <el-button size="mini" @click="addProductDetail(scope.row)">保存</el-button>
                        <el-button size="mini" type="danger" @click="handleDelete(props.row, scope.$index)">删除</el-button>
                      </template>
                      <template v-else>
                        <el-button
                          size="mini"
                          v-if="(scope.row.orderStatus == 1 || scope.row.orderStatus == 0) && (user.isAdmin || user.isKf)" 
                          @click="showModifyOrder(scope.row, 1)">编辑</el-button>
                        <el-popconfirm
                          size="mini"
                          v-if="(((scope.row.orderStatus == 3 || scope.row.orderStatus == 4 || scope.row.orderStatus == 5 || scope.row.orderStatus == 6 ) && props.row.totalAmount > 0) 
                          && props.row.childList.length>1) && (user.isAdmin || user.isKf)"
                          @confirm="cancelSubOrder(scope.row, 4)"
                          title="确定要取消这条记录吗？">
                          <el-button slot="reference"
                          type="danger"
                          size="mini">取消</el-button>
                        </el-popconfirm>
                        <el-button
                          size="mini"
                          v-if="(((scope.row.orderStatus == 2 || scope.row.orderStatus == 3) && props.row.isRebating == 0) 
                          || props.row.orderStatus == 6) && (user.isAdmin || user.isKf) "
                          @click="showModifyOrder(scope.row, 2)">附加</el-button>
                        <el-button
                          v-if="(((scope.row.orderStatus == 2 || scope.row.orderStatus == 3) || scope.row.isRebating == 1)
                           && scope.row.totalAmount > 0) && (user.isAdmin || user.isKf)"
                          size="mini"
                          @click="showModifyOrder(scope.row, 3)">优惠</el-button>
                      </template>
                    </template>
                  </el-table-column>
                </el-table>
                <template v-if="props.row.orderStatus == 1">
                    <div style="text-align:center; padding: 10px">
                      <el-button size="mini" type="primary" icon="el-icon-circle-plus-outline" circle @click="addProductList(props.row)"></el-button>
                    </div>
                </template>
              </el-tab-pane>
              <el-tab-pane label="交易记录" name="third">
                <template v-if="props.row.payRecordList.length > 0">
                  <el-table
                    :data="props.row.payRecordList"
                    :row-class-name="tradeRowClassName"
                    style="height:100%;"
                    border>
                    <el-table-column
                      fixed
                      prop="supplementNo"
                      label="支付编号"
                      width="220">
                    </el-table-column>
                    <el-table-column
                      prop="outPayNo"
                      label="第三方支付编号"
                      width="260">
                    </el-table-column>
                    <el-table-column
                      prop="payType"
                      :formatter="formatPayType"
                      show-overflow-tooltip
                      label="支付类型"
                      width="80">
                    </el-table-column>
                    <el-table-column
                      prop="payStatus"
                      label="状态"
                      width="80">
                      <template slot-scope="scope">
                        <span v-if="scope.row.payStatus == 1" style="color:#F56C6C">待处理</span>
                        <span v-if="scope.row.payStatus == 2" style="color:#67C23A">已完成</span>
                        <span v-if="scope.row.payStatus == 4" style="color:#F56C6C">预付订单</span>
                      </template>
                    </el-table-column>
                    <el-table-column
                      prop="payMethod"
                      :formatter="formatPay"
                      label="付款方式"
                      width="80">
                    </el-table-column>
                    <el-table-column
                      prop="payAmount"
                      label="付款金额"
                      width="100">
                    </el-table-column>
                    <el-table-column
                      prop="realAmount"
                      label="可退金额"
                      width="100">
                    </el-table-column>
                    <el-table-column
                      prop="rebateAmount"
                      label="已退金额"
                      width="100">
                    </el-table-column>
                    <el-table-column
                      prop="reason"
                      show-overflow-tooltip
                      label="备注">
                    </el-table-column>
                    <el-table-column
                      prop="operateUser"
                      show-overflow-tooltip
                      label="操作人">
                    </el-table-column>
                    <el-table-column
                      prop="updateDate"
                      show-overflow-tooltip
                      label="操作时间">
                    </el-table-column>
                    <el-table-column
                      show-overflow-tooltip
                      prop="payTime"
                      label="付款时间"
                      width="160">
                    </el-table-column>
                    <el-table-column
                      width="160"
                      label="操作" >
                      <template slot-scope="scope">
                        <el-button v-if="(((scope.row.payMethod == 3 && scope.row.payStatus == 1 && (scope.row.payType == 1 || scope.row.payType == 2)) 
                          || (scope.row.payMethod == null && scope.row.payType != 3)) && scope.row.payAmount > 0) && (user.isAdmin || user.isCw)"
                          size="mini"
                          @click="confirmPay(scope.row)">确认收款</el-button>
                        <el-popconfirm
                          size="mini"
                          v-if="(scope.row.payStatus == 2 && (scope.row.payType == 1 || scope.row.payType == 2) && scope.row.realAmount > 0) && (user.isAdmin || user.isKf)"
                          @confirm="refundModifyOrder(scope.row)"
                          title="确定要申请退还这笔款项吗？">
                          <el-button slot="reference"
                          type="danger"
                          size="mini">申请退款</el-button>
                        </el-popconfirm>
                      </template>
                    </el-table-column>
                  </el-table>
                  <template v-if="(props.row.orderStatus == 21 ||props.row.orderStatus == 41 || props.row.orderStatus == 2) && (user.isAdmin || user.isCw)">
                    <div class="invoice-css">
                      <el-button
                        size="mini"
                        @click="confirmPayOrder(props.row)">确认收款</el-button>
                    </div>
                  </template>
                </template>
              </el-tab-pane>
              <el-tab-pane label="收货信息" name="second">
                <el-form ref="addressForm" :model="addressForm" class="invoiceCss">
                  <el-form-item label="收货地址" :label-width="formLabelWidth">
                    <el-input v-model="props.row.receiveAddress"  autocomplete="off"></el-input>
                  </el-form-item>
                  <el-form-item label="联系人" :label-width="formLabelWidth">
                    <el-input v-model="props.row.receiveUser"  autocomplete="off"></el-input>
                  </el-form-item>
                  <el-form-item label="联系方式" :label-width="formLabelWidth">
                    <el-input v-model="props.row.receiveMobile"  autocomplete="off"></el-input>
                  </el-form-item>
                  <el-form-item label="收货备注" :label-width="formLabelWidth">
                    <el-input v-model="props.row.userRemark"  autocomplete="off"></el-input>
                  </el-form-item>
                  <el-form-item style="margin-left:140px">
                    <el-button type="primary" @click="onSubmitAddress(props.row)">立即保存</el-button>
                  </el-form-item>
                </el-form>
              </el-tab-pane>
              <el-tab-pane label="发票信息" name="fourth">
                <template v-if="props.row.userInvoiceResponseVo">
                  <el-form class="invoiceCss">
                    <el-form-item label="发票类型" :label-width="formLabelWidth">
                    <el-select v-model="props.row.userInvoiceResponseVo.type" placeholder="请选择">
                      <el-option
                        v-for="item in options"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                      </el-option>
                    </el-select>
                    </el-form-item>
                    <el-form-item label="发票抬头" :label-width="formLabelWidth"> 
                      <el-input v-model="props.row.userInvoiceResponseVo.companyName"  autocomplete="off"></el-input>
                    </el-form-item>
                    <el-form-item label="税务登记号" :label-width="formLabelWidth">
                      <el-input v-model="props.row.userInvoiceResponseVo.invoiceNumber" autocomplete="off"></el-input>
                    </el-form-item>
                    <el-form-item label="邮箱" :label-width="formLabelWidth">
                      <el-input v-model="props.row.userInvoiceResponseVo.email" autocomplete="off"></el-input>
                    </el-form-item>
                    <el-form-item label="公司注册地址" :label-width="formLabelWidth" v-show="props.row.userInvoiceResponseVo.type == 2">
                      <el-input v-model="props.row.userInvoiceResponseVo.companyAddress" autocomplete="off"></el-input>
                    </el-form-item>
                    <el-form-item label="公司电话" :label-width="formLabelWidth" v-show="props.row.userInvoiceResponseVo.type == 2">
                      <el-input v-model="props.row.userInvoiceResponseVo.companyMobile" autocomplete="off"></el-input>
                    </el-form-item>
                    <el-form-item label="开户银行" :label-width="formLabelWidth" v-show="props.row.userInvoiceResponseVo.type == 2">
                      <el-input v-model="props.row.userInvoiceResponseVo.bankName" autocomplete="off"></el-input>
                    </el-form-item>
                    <el-form-item label="开户银行账号" :label-width="formLabelWidth" v-show="props.row.userInvoiceResponseVo.type == 2">
                      <el-input v-model="props.row.userInvoiceResponseVo.bankNumber" autocomplete="off"></el-input>
                    </el-form-item>
                    <el-form-item label="收票人" :label-width="formLabelWidth" v-show="props.row.userInvoiceResponseVo.type == 2">
                      <el-input v-model="props.row.userInvoiceResponseVo.consignee" autocomplete="off"></el-input>
                    </el-form-item>
                    <!-- <el-form-item label="收票地址" :label-width="formLabelWidth" v-show="props.row.userInvoiceResponseVo.type == 2">
                      <el-input v-model="props.row.userInvoiceResponseVo.addressDetail" autocomplete="off"></el-input>
                    </el-form-item> -->
                    <el-form-item label="手机号码" :label-width="formLabelWidth" v-show="props.row.userInvoiceResponseVo.type == 2">
                      <el-input v-model="props.row.userInvoiceResponseVo.mobile" autocomplete="off"></el-input>
                    </el-form-item>
                    <el-form-item label="电子版盖章开票信息" :label-width="formLabelWidth" v-show="props.row.userInvoiceResponseVo.type == 2">
                      <el-image :src="props.row.userInvoiceResponseVo.invoiceFile" style="width: 500px;"></el-image>
                    </el-form-item>
                  </el-form>
                </template>
                <template v-else>
                  <div style="padding: 10px 0 20px 0; width: 60%; text-align:center;">
                    暂无
                  </div>
                </template>
              </el-tab-pane>
              <el-tab-pane label="合同记录" name="five">
                <template v-if="props.row.contractRecordList">
                  <el-table
                    :data="props.row.contractRecordList"
                    border
                    style="width: 75%">
                    <el-table-column
                      prop="contractNo"
                      show-overflow-tooltip
                      label="合同编号">
                    </el-table-column>
                    <el-table-column
                      prop="consignee"
                      show-overflow-tooltip
                      label="合同下载">
                      <template slot-scope="scope">
                        <a target="_blank" :href="scope.row.contractPath">查看</a>
                      </template>
                    </el-table-column>
                    <el-table-column
                      prop="createDate"
                      show-overflow-tooltip
                      label="合同时间">
                    </el-table-column>
                    <el-table-column
                      label="操作" >
                      <template slot-scope="scope">
                        <el-popconfirm
                          v-if="user.isAdmin || user.isKf"
                          size="mini"
                          @confirm="deleteContract(props.row, scope.row)"
                          title="确定要要删除改合同信息吗？">
                          <el-button slot="reference"
                          type="danger"
                          size="mini">删除</el-button>
                        </el-popconfirm>
                      </template>
                    </el-table-column>
                  </el-table>
                </template>
                <template v-else>
                  <div v-if="(props.row.orderStatus != 7 || props.row.orderStatus != 8) 
                      && props.row.invoiceId && props.row.userInvoiceResponseVo && props.row.userInvoiceResponseVo.type == 2  && (user.isAdmin || user.isKf)"  
                      class="invoice-css">
                    <el-button
                      size="mini"
                      @click="createContract(props.row)">合同</el-button>
                  </div>
                  <div class="invoice-css" v-else>
                    当前数据无法生成合同
                  </div>
                </template>
              </el-tab-pane>
              <el-tab-pane label="历史订单记录" name="six">
                <el-table :data="historyData" border style="height:100%;">
                  <el-table-column
                    fixed
                    prop="orderNo"
                    label="子订单编号"
                    width="210">
                  </el-table-column>
                  <el-table-column
                    prop="manufacturerNumber"
                    show-overflow-tooltip
                    label="产品型号"
                    width="160">
                  </el-table-column>
                  <el-table-column
                    prop="brandName"
                    show-overflow-tooltip
                    label="品牌"
                    width="110">
                  </el-table-column>
                  <el-table-column
                    prop="originalPrice"
                    show-overflow-tooltip
                    label="商品原单价"
                    width="100">
                  </el-table-column>
                  <el-table-column
                    prop="discountedPrice"
                    show-overflow-tooltip
                    label="购买价格"
                    width="100">
                  </el-table-column>
                  <el-table-column
                    prop="count"
                    label="购买数量"
                    width="80">
                  </el-table-column>
                  <el-table-column
                    prop="sendCount"
                    label="发货数量"
                    width="80">
                  </el-table-column>
                  <el-table-column
                    prop="attachAmount"
                    label="附加费"
                    width="80">
                  </el-table-column>
                  <el-table-column
                    prop="preferentialMargins"
                    label="总优惠"
                    width="80">
                  </el-table-column>
                  <el-table-column
                    label="状态"
                    width="80">
                    <template slot-scope="scope">
                      <span v-if="scope.row.orderStatus == -4" style="color:#989998">支付失败</span>
                      <span v-if="scope.row.orderStatus == -3" style="color:#ccc">已退款</span>
                      <span v-if="scope.row.orderStatus == -2" style="color:#989998">退款申请</span>
                      <span v-if="scope.row.orderStatus == -1" style="color:#ccc">已取消</span>
                      <span v-if="scope.row.orderStatus == 0" style="color:#F56C6C">待确认</span>
                      <span v-if="scope.row.orderStatus == 1" style="color:#F56C6C">待付款</span>
                      <span v-if="scope.row.orderStatus == 2" style="color:#E6A23C">部分付款</span>
                      <span v-if="scope.row.orderStatus == 21" style="color:#F56C6C">预付订单</span>
                      <span v-if="scope.row.orderStatus == 3" style="color:#67C23A">待审核</span>
                      <span v-if="scope.row.orderStatus == 4" style="color:#E6A23C">待发货</span>
                      <span v-if="scope.row.orderStatus == 5" style="color:#E6A23C">发货中</span>
                      <span v-if="scope.row.orderStatus == 6" style="color:#409EFF">已发货</span>
                      <span v-if="scope.row.orderStatus == 7" style="color:#F56C6C">已完成</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="originalAmount"
                    label="原总金额"
                    width="95">
                  </el-table-column>
                  <el-table-column
                    prop="totalAmount"
                    label="总金额"
                    width="95">
                  </el-table-column>
                  <el-table-column
                    prop="remark"
                    label="备注">
                  </el-table-column>
                </el-table>
                <pagination :pagination="hisPagination" v-on:paginationClick="queryHistoryPagination"></pagination>
              </el-tab-pane>
              <el-tab-pane label="发票记录" name="seven">
                <template v-if="props.row.invoiceRecordList">
                  <el-table
                    :data="props.row.invoiceRecordList"
                    border
                    style="width: 100%">
                    <el-table-column
                      prop="invoiceNo"
                      show-overflow-tooltip
                      label="发票编号">
                    </el-table-column>
                    <el-table-column
                      prop="amount"
                      show-overflow-tooltip
                      label="发票金额">
                    </el-table-column>
                    <el-table-column
                      label="状态"
                      width="80">
                      <template slot-scope="scope">
                        <span v-if="scope.row.status == 1" style="color:#989998">开票申请中</span>
                        <span v-if="scope.row.status == 2" style="color:#67C23A">已开票</span>
                      </template>
                    </el-table-column>
                    <el-table-column
                      prop="trackNo"
                      show-overflow-tooltip
                      label="发票物流">
                    </el-table-column>
                    <el-table-column
                      prop="trackNo"
                      show-overflow-tooltip
                      label="发票物流">
                    </el-table-column>
                    <el-table-column
                      prop="companyName"
                      show-overflow-tooltip
                      label="开票企业">
                    </el-table-column>
                    <el-table-column
                      prop="companyAddress"
                      show-overflow-tooltip
                      label="发票地址">
                    </el-table-column>
                    <el-table-column
                      prop="invoiceNumber"
                      show-overflow-tooltip
                      label="企业税号">
                    </el-table-column>
                    <el-table-column
                      prop="consignee"
                      show-overflow-tooltip
                      label="收件人">
                    </el-table-column>
                    <el-table-column
                      prop="mobile"
                      show-overflow-tooltip
                      label="联系方式">
                    </el-table-column>
                    <el-table-column
                      prop="createDate"
                      show-overflow-tooltip
                      label="开票时间">
                    </el-table-column>
                    <el-table-column
                      width="160"
                      label="操作" >
                      <template slot-scope="scope">
                          <el-button slot="reference"
                          type="danger"
                          v-if="scope.row.fileList"
                          @click="handleShowInvoices(scope.row.fileList)"
                          size="mini">查看发票</el-button>
                      </template>
                    </el-table-column>
                  </el-table>
                </template>
              </el-tab-pane>
            </el-tabs>
          </template>
        </el-table-column>
        <el-table-column
          prop="orderNo"
          label="订单编号"
          show-overflow-tooltip
          width="186">
        </el-table-column>
        <el-table-column
          prop="createDate"
          show-overflow-tooltip
          label="下单时间"
          width="142">
        </el-table-column>
        <el-table-column
          label="登录用户"
          show-overflow-tooltip
          size= "small"
          width="114">
          <template slot-scope="scope">
            <el-popover
              v-if="scope.row.orderStatus != -1 && scope.row.orderStatus != -3"
              placement="top"
              size= "small"
              title="收货信息"
              trigger="click">
              <p>登录名: {{ scope.row.userName }}</p>
              <p>收货人: {{ scope.row.receiveUser }}</p>
              <p>联系方式: {{ scope.row.receiveMobile }}</p>
              <p>收货地址: {{ scope.row.receiveAddress }}</p>
              <p>收货备注: {{ scope.row.userRemark }}</p>
              <el-button type="text" slot="reference">{{ scope.row.userName }}</el-button>
            </el-popover>
            <span v-else>{{ scope.row.userName }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="用户名"
          prop="receiveUser"
          show-overflow-tooltip
          width="80">
        </el-table-column>
        <el-table-column
          label="商品金额"
          prop="originalAmount"
          show-overflow-tooltip
          width="100">
        </el-table-column>
        <el-table-column
          label="附加费用"
          prop="attachAmount"
          show-overflow-tooltip
          width="80">
        </el-table-column>
        <!-- <el-table-column
          prop="rebateAmount"
          label="退款金额"
          width="100">
        </el-table-column> -->
        <el-table-column
          label="应付金额"
          show-overflow-tooltip
          size= "small"
          width="108">
          <template slot-scope="scope">
            <el-popover trigger="hover" placement="left" v-if="scope.row.orderStatus != -1 && scope.row.orderStatus != -3">
              <p>商品金额: {{ scope.row.discountedAmount }}</p>
              <p>总优惠: {{ scope.row.preferentialMargins }}</p>
              <p>运费: {{ scope.row.transportAmount }}</p>
              <p>应付金额: {{ scope.row.totalAmount }}</p>
              <div slot="reference" class="name-wrapper">
                <el-tag size="mini">{{ scope.row.totalAmount }}</el-tag>
              </div>
            </el-popover>
            <span v-else>{{ scope.row.totalAmount }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="payAmount"
          label="实收款"
          width="100">
        </el-table-column>
        <el-table-column
          label="状态"
          width="92">
          <template slot-scope="scope">
            <span v-if="scope.row.orderStatus == -4" style="color:#989998"><el-tag size="mini" type="danger">支付失败</el-tag></span>
            <span v-if="scope.row.orderStatus == -3">已退款</span>
            <span v-if="scope.row.orderStatus == -2" style="color:#989998"><el-tag size="mini" type="danger">退款申请</el-tag></span>
            <span v-if="scope.row.orderStatus == -1">已取消</span>
            <span v-if="scope.row.orderStatus == 0" style="color:#F56C6C"><el-tag size="mini" type="danger" effect="dark">待确认</el-tag></span>
            <span v-if="scope.row.orderStatus == 1" style="color:#F56C6C"><el-tag size="mini" type="danger" effect="dark">待付款</el-tag></span>
            <span v-if="scope.row.orderStatus == 2" style="color:#E6A23C"><el-tag size="mini" type="warning">部分付款</el-tag></span>
            <span v-if="scope.row.orderStatus == 21" style="color:#F56C6C"><el-tag size="mini" type="warning">预付订单</el-tag></span>
            <span v-if="scope.row.orderStatus == 3" style="color:#67C23A">
              <el-tooltip class="item" effect="dark" content="部分退款申请，请及时处理" placement="top-start" v-if="scope.row.isRebating == 1">
                <el-tag size="mini" type="danger">预处理</el-tag>
              </el-tooltip>
              <span v-else>
                <el-tag size="mini" type="success">待审核</el-tag>
              </span>
            </span>
            <span v-if="scope.row.orderStatus == 4" style="color:#67C23A">
              <el-tooltip class="item" effect="dark" content="部分退款申请，请及时处理" placement="top-start" v-if="scope.row.isRebating == 1">
                <el-tag size="mini" type="danger">预处理</el-tag>
              </el-tooltip>
              <span v-else>
                <el-tag size="mini" type="warning">待发货</el-tag>
              </span>
            </span>
            <span v-if="scope.row.orderStatus == 41" style="color:#E6A23C"><el-tag size="mini" type="warning">未付审批</el-tag></span>
            <span v-if="scope.row.orderStatus == 5" style="color:#67C23A">
              <el-tooltip class="item" effect="dark" content="部分退款申请，请及时处理" placement="top-start" v-if="scope.row.isRebating == 1">
                <el-tag size="mini" type="danger">预处理</el-tag>
              </el-tooltip>
              <span v-else>
                <el-tag size="mini" type="success">发货中</el-tag>
              </span>
            </span>
            <span v-if="scope.row.orderStatus == 6" style="color:#409EFF"><el-tag size="mini">已发货</el-tag></span>
            <span v-if="scope.row.orderStatus == 61" style="color:#409EFF"><el-tag size="mini">未付发货</el-tag></span>
            <span v-if="scope.row.orderStatus == 7" style="color:#F56C6C"><el-tag size="mini" type="info">已完成</el-tag></span>
          </template>
        </el-table-column>
        <el-table-column
          prop="ipAddress"
          label="ip所在地"
          show-overflow-tooltip
          width="130">
        </el-table-column>
        <el-table-column prop="remark" label="备注"
          show-overflow-tooltip>
          <template scope="scope" >
            <span v-if="scope.row.index === cellRemark.tabMainIndex && cellRemark.tabMainLabel === '备注'">
              <el-input size="small"
               v-model="cellRemark.remark.main" placeholder="请输入内容" @blur="handleRemarkEdit(scope.row)"/>
            </span>
            <template v-else>
              <span>{{scope.row.remark}}</span>
            </template>
          </template>
        </el-table-column>
        <el-table-column
          prop="isInvoice"
          align="center"
          width="64"
          label="发票"
          show-overflow-tooltip>
          <template slot-scope="scope">
            <span v-if="scope.row.isInvoice == -1 && scope.row.orderStatus > 2" style="color:#ccc">不需要</span>
            <span v-if="scope.row.isInvoice == 1 && scope.row.orderStatus > 2" style="color:#909399">未开</span>
            <span v-if="scope.row.isInvoice == 2 && scope.row.orderStatus > 2" style="color:#E6A23C">申请中</span>
            <span v-if="scope.row.isInvoice == 3 && scope.row.orderStatus > 2" style="color:#409EFF">已开具</span>
            <span v-if="scope.row.orderStatus <= 1" style="color:#ccc;">—</span>
          </template>
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          label="物流"
          width="64">
          <template slot-scope="scope">
            <span v-if="scope.row.transId == 1" style="color:#ccc">顺丰</span>
            <span v-if="scope.row.transId == 8" style="color:#ccc">京东</span>
            <span v-if="scope.row.transId == 0" style="color:#ccc">默认</span>
            <span v-if="scope.row.transId == -1" style="color:#ccc">到付</span>
          </template>
        </el-table-column>
        <el-table-column
            show-overflow-tooltip
            prop="bdSource"
            label="来源"
            width="64">
          </el-table-column>
        <el-table-column
          width="140"
          fixed="right"
          label="操作" >
          <template slot-scope="scope">
            <span v-if="scope.row.orderStatus == -1" class="el-icon-circle-close"></span>
            <span v-if="scope.row.orderStatus == -3 || scope.row.orderStatus == -2" class="el-icon-close"></span>
            <span v-if="scope.row.orderStatus === 6 && (scope.row.isInvoice == -1 || scope.row.isInvoice == 3)" class="el-icon-s-flag"></span>
            <span v-if="scope.row.orderStatus === 7 && (scope.row.isInvoice == -1 || scope.row.isInvoice == 3)" class="el-icon-circle-check"></span>
            <el-popconfirm
              size="mini"
              v-if="scope.row.orderStatus == 0 && (user.isAdmin || user.isKf)"
              @confirm="confirmOrder(scope.row)"
              title="价格/库存不明，确定要确定这笔交易吗？">
              <el-button slot="reference"
              type="text"
              size="mini">确定</el-button>
            </el-popconfirm>
            <el-popconfirm
              size="mini"
              v-if="(scope.row.orderStatus == 1 || scope.row.orderStatus == 0) && (user.isAdmin || user.isKf)"
              @confirm="cancelOrder(scope.row)"
              title="确定要取消这条记录吗？">
              <el-button slot="reference"
              type="text"
              size="mini">取消</el-button>
            </el-popconfirm>
            <el-popconfirm
              size="mini"
              v-if="(scope.row.orderStatus >= 3 && scope.row.orderStatus <=7 && scope.row.isInvoice != -1) && (user.isAdmin || user.isKf) "
              @confirm="removeInvoiceRecord(scope.row)"
              title="确定要这条记录不需要开票吗？">
              <el-button slot="reference"
              title="禁开发票"
              type="text"
              size="mini">禁开</el-button>
            </el-popconfirm>
            <el-popconfirm
              size="mini"
              v-if="(scope.row.orderStatus == 1 || scope.row.orderStatus == 2 ||scope.row.orderStatus == 21) &&(user.isAdmin || user.isCw) "
              @confirm="bestSendGoods(scope.row)"
              title="审核该笔订单优先发货">
              <el-button slot="reference"
              title="优先审批发货"
              type="text"
              size="mini">审批</el-button>
            </el-popconfirm>
            <el-popconfirm
              @confirm="addNewOrder(scope.row)"
              title="对该用户新增一个订单？">
              <el-button slot="reference"
              title="新增订单"
              type="text"
              size="mini">新增</el-button>
            </el-popconfirm>
          </template>
        </el-table-column>
      </el-table>
      <pagination :pagination="pagination" v-on:paginationClick="queryPagination"></pagination>
    </el-tab-pane>
    <el-dialog :title="title" :visible.sync="dialogOrderFormVisible" width="780px">
      <el-form :model="invoiceParam">
        <el-form-item label="主订单编号" :label-width="formLabelWidth">
          <el-input v-model="modifyOrderForm.orderNo" autocomplete="off" disabled></el-input>
        </el-form-item>
        <el-form-item label="订单编号" :label-width="formLabelWidth">
          <el-input v-model="modifyOrderForm.subOrderNo" autocomplete="off" disabled></el-input>
        </el-form-item>
        <el-form-item label="产品价格" :label-width="formLabelWidth">
          <el-input v-model="modifyOrderForm.price" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="产品数量" :label-width="formLabelWidth">
          <el-input v-model="modifyOrderForm.count" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="mini" v-if="editorMehotd == 1" @click="modifySubmitOrder">确定</el-button>
        <el-button size="mini" v-if="editorMehotd == 2" @click="modifyAttachAmountOrder">确定</el-button>
        <el-button size="mini" v-if="editorMehotd == 3" @click="modifyRebateAmountOrder">确定</el-button>
        <el-button size="mini" @click="dialogOrderFormVisible = false">取 消</el-button>
      </div>
    </el-dialog>
    <el-dialog title="开票信息列表" :visible.sync="isInvoiceShow" :close-on-click-modal="false">
      <el-table :data="invoiceList" style="width: 100%">
        <el-table-column
          label="序号"
          type="index"
          width="50">
        </el-table-column>
        <el-table-column
          prop="name"
          label="图片名称">
          <template slot-scope="scope">
            <a :href="scope.row.url" target="_blank">{{scope.row.name}}</a>
          </template>
        </el-table-column>
        <el-table-column
          prop="url"
          label="图片地址">
        </el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button size="mini" @click="isInvoiceShow = false">关 闭</el-button>
      </div>
    </el-dialog>
   </el-tabs>
</template>
<script>
import pagination from "../../common/util/pagination";

export default {
  data() {
    return {
      data: [],
      expands: [],
      orderNos: '',
      loading: false,
      isInvoiceShow: false,
      invoiceList: [],
      productOtions:[],
      cellRemark: {
        tabMainIndex : '',
        tabMainLabel : '',
        tabSubIndex : '',
        tabSubLabel : '',
        remark: {
          main: '',
          sub: ''
        },
      },
      roleId: this.user.getUserData().roleId,
      addressForm: {
        token: this.user.getToken(),
        orderNo: "",
        receiveAddress: "",
        receiveUser:"",
        receiveMobile: "",
        userRemark: ""
      },
      historyData: [],
      optionItem: {},
      formLabelWidth: '140px',
      dialogFormVisible:false,
      discountedPrice: 0 , // 原价
      title: '编辑子订单信息',
      editorMehotd: 1,
      dialogOrderFormVisible: false,
      activeName: 'first',
      addressList: [],
      payList:[],
      getRowKeys: (row) => {
        return row.orderNo   
      },
      order: {
        payType: '',
        orderNo: '',
        isBelong: false,
        isCancel: true,
        orderStatus:'',
        isSource: '',
        orderTime:  [],
        payTime: [],
        token: this.user.getToken()
      },
      historyOrder: {
        userId: '',
        token: this.user.getToken()
      },
      cellCost: {
        tabCostIndex : '',
        tabCostLabel : '',
        price: 0
      },
      contract: {
        orderNo: '',
        token: this.user.getToken()
      },
      delelteContractForm: {
        id: 0,
        token: this.user.getToken()
      },
      modifyOrderForm: {
        orderNo: '',
        subOrderNo: '',
        count: 0,
        price: 0,
        token: this.user.getToken()
      },
      readPayOrderForm: {
        orderNo: '',
        token: this.user.getToken()
      },
      invoiceParam: {
      },
      pagination: {
        pageSize: 10,
        pageNum: 1,
        pageTotal: 0
      },
      hisPagination: {
        pageSize: 10,
        pageNum: 1,
        pageTotal: 0
      },
      options: [{
          value: 1,
          label: '普通发票'
        }, {
          value: 2,
          label: '专用发票'
        }, {
          value: 3,
          label: '个人'
        }]
    };
  },
  components: {
    pagination
  },
  methods: {
    mainTabClick: function(row, column, cell, event) {
      this.cellRemark.tabMainIndex = row.index
      this.cellRemark.tabMainLabel = column.label
      this.cellRemark.remark.main = row.remark
    },
    searchProduct: function(query) {
      if (query !== '') {
        this.loading = true;
        setTimeout(() => {
         this.loading = false;
        this.http.post(
        '/productDetail/list', 
        {
          manufacturerNumber: query,
          token: this.user.getToken()
        }, res => {
          if (res.success) {
            // 返回正确的处理
            this.productOtions = res.datas.data
          } else {
            // 返回错误的处理
            this.$message.error(res.message)
          }
        });
        }, 200);
      } else {
        this.options = [];
      }
    },
    addProductList: function(row) {
      row.childList.push({
        "productId":null,
        "mainOrderNo":row.orderNo,
        "orderNo": null,
        "productLocalLogo":null,
        "manufacturerNumber":null,
        "brandId":null,
        "brandName":null,
        "describe":null,
        "platformId":null,
        "count":1,
        "sendCount":0,
        "originalPrice":0,
        "discountedPrice":0,
        "preferentialMargins":0,
        "attachAmount":0,
        "rate":0.0,
        "originalAmount":null,
        "rebateAmount":0,
        "totalAmount":null,
        "orderStatus":1,
        "remark":null,
        "stockState":null,
        "isAdd": 1
        });
    },
    handleDelete(row, index) {
				row.childList.splice(index, 1);
		},
    addProductDetail: function(row) {
      // 判断该订单下是否存在需要发货的字订单
      row.token = this.user.getToken()
      // 判断该订单下是否存在需要发货的字订单
      this.http.post(
      '/order/detail/add', 
      row, res => {
        if (res.success) {
          // 返回正确的处理
          this.getOrderData();
        } else {
          // 返回错误的处理
          this.$message.error(res.message)
        }
      });
    },
    subTabClick: function(row, column, cell, event) {
      if (column.label == '备注') {
        this.cellRemark.tabSubIndex = row.index
        this.cellRemark.tabSubLabel = column.label
        this.cellRemark.remark.sub = row.remark
      }else if (column.label == '成本价') {
        this.cellCost.tabCostIndex = row.index
        this.cellCost.tabCostLabel = column.label
        this.cellCost.price= row.costPrice
      }

    },
    // 退款申请
    refundModifyOrder: function(row) {
      // 判断该订单下是否存在需要发货的字订单
      this.http.post(
      '/order/refund/apply', 
      {
        supplementNo: row.supplementNo,
        payType: row.payType,
        token: this.user.getToken()
      }, res => {
        if (res.success) {
          // 返回正确的处理
          this.getOrderData();
        } else {
          // 返回错误的处理
          this.$message.error(res.message)
        }
      });
    },
    // 编辑
    modifySubmitOrder: function() {
      this.http.post(
        '/order/modify/buyProduct',
        this.modifyOrderForm,
        res => {
          if (res.success) {
            // 返回正确的处理
            this.getOrderData();
          } else {
            // 返回错误的处理
            this.$message.error(res.message)
          }
      })
      this.dialogOrderFormVisible = false
    },
    // 附加费
    modifyAttachAmountOrder: function() {
      this.http.post(
      '/order/attach/amount',
      this.modifyOrderForm,
      res => {
        if (res.success) {
          // 返回正确的处理
          this.getOrderData();
        } else {
          // 返回错误的处理
          this.$message.error(res.message)
        }
      })
      this.dialogOrderFormVisible = false
    },
    modifyRebateAmountOrder: function() {
      // if (this.modifyOrderForm.price <= this.discountedPrice) {
        this.http.post(
        '/order/rebate/amount',
        this.modifyOrderForm,
        res => {
          if (res.success) {
            // 返回正确的处理
            this.getOrderData()
          } else {
            // 返回错误的处理
            this.$message.error(res.message)
          }
        })
        this.dialogOrderFormVisible = false
      // } else {
      //   this.$message.error('优惠退还，商品单价必须小于原单价！')
      // }
    },
    handleClick(sval) {
      if (this.activeName =='six') {
        this.historyOrder.userId = sval.userId
        this.getHistoryOrderData()
      }
    },
    openExpand: function(row, rowList) {
      this.activeName = 'first'
      this.loading = true
      var that = this
      if (rowList.length) { // 只展开一行//说明展开了
        that.expands = []
        if (row) {
          that.expands.push(row.orderNo)// 只展开当前行id
        }
      //  this.tablaData(row.eqId)  这里可以调用接口数据渲染
      } else { // 说明收起了
        that.expands = []
      }
    },
    showModifyOrder: function(rows, val) {
      this.discountedPrice = rows.discountedPrice
      if (val == 2) {
        this.title = '附加费'
      }else if (val == 3) {
        this.title = '优惠退还'
      }
      this.editorMehotd = val
      // 编辑订单
      this.dialogOrderFormVisible = true
      this.modifyOrderForm.orderNo = rows.mainOrderNo
      this.modifyOrderForm.subOrderNo = rows.orderNo
      this.modifyOrderForm.count = rows.count
      this.modifyOrderForm.price = rows.discountedPrice
    },
    cancelSubOrder: function(rows) {
        // 判断该订单下是否存在需要发货的字订单
      this.http.post('/order/sub/cancel', 
        {
          orderNo: rows.mainOrderNo,
          subOrderNo: rows.orderNo,
          token: this.user.getToken()
        }, res => {
          if (res.success) {
            // 返回正确的处理
            this.getOrderData();
          } else {
            // 返回错误的处理
            this.$message.error(res.message)
          }
      });
    },
    confirmPay: function(rows) {
      // 判断该订单下是否存在需要发货的字订单
      this.$prompt('是否确认付款了该笔交易订单', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
        }).then(({ value }) => {
          this.http.post(
            '/confirmPay/apply',
            {
              orderNo: rows.mainOrderNo,
              payAmount: value,
              token: this.user.getToken()
            }, res => {
              if (res.success) {
                // 返回正确的处理
                this.getOrderData();
              } else {
                // 返回错误的处理
                this.$message.error(res.message)
              }
          });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '取消输入'
          });       
      });
    },
    confirmPayOrder: function(rows) {
      // 判断该订单下是否存在需要发货的字订单
      this.$prompt('是否确认付款了该笔交易订单', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
        }).then(({ value }) => {
          this.http.post(
            '/confirmPay/apply',
            {
              orderNo: rows.orderNo,
              payAmount: value,
              token: this.user.getToken()
            }, res => {
              if (res.success) {
                // 返回正确的处理
                this.getOrderData();
              } else {
                // 返回错误的处理
                this.$message.error(res.message)
              }
          });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '取消输入'
          });       
      });
    },
    createContract: function(rows) {
      this.contract.orderNo = rows.orderNo
      // 初始化默认加载菜单
      this.http.post(
        '/contract/create',
        this.contract,
        res => {
          if (res.success) {
            this.getOrderData()
          } else {
            // 返回错误的处理
            this.$message.error(res.message)
          }
        }
      );
    },
    deleteContract: function(row, rows) {
      this.delelteContractForm.id = rows.id
      // 初始化默认加载菜单
      this.http.post('/contract/delete',
        this.delelteContractForm,
        res => {
          if (res.success) {
            row.contractRecordList = null
          } else {
            // 返回错误的处理
            this.$message.error(res.message)
          }
        }
      );
    },
    tableRowClassName({row, rowIndex}) {
      row.index = rowIndex
      if (row.orderStatus === -1) {
        return 'del_line efficacy-row'
      }else if(row.orderStatus === -3){
        return 'success-refund del_refund_line efficacy-row'
      } else if (row.orderStatus === 0) {
        return ''
      } else if (row.orderStatus === 1 || row.orderStatus === 2 || row.orderStatus === 21) {
        return 'success-paid'
      } else if (row.orderStatus === 3) {
        return  'success-row'
      } else if (row.orderStatus === 4 || row.orderStatus === 5) {
        return 'remind-row'
      }else if (row.orderStatus === 8) {
        return 'success-refund'
      }else if (row.orderStatus === 6) {
        return 'success-over'
      }
      return '';
    },
    tableRowName({row, rowIndex}) {
      row.index = rowIndex
      if (row.orderStatus === -1) {
        return 'del_line efficacy-row'
      }else if(row.orderStatus === -3){
        return 'success-refund del_refund_line efficacy-row'
      }
      return '';
    },
    tradeRowClassName({row, rowIndex}) {
      row.index = rowIndex
      if (row.payAmount === 0) {
        return 'del_line efficacy-row'
      }
      return '';
    },
    formatStockState: function(row, column, cellValue) {
      if (cellValue === 0) {
        return "digikey";
      } else if (cellValue === 10) {
        return "京北通宇";
      } else if (cellValue === 8) {
        return "国内现货";
      } else if (cellValue === 4) {
        return "云汉商城";
      } else if (cellValue === 5) {
        return "华强商城";
      } else if (cellValue === 6) {
        return "维样商城";
      } else if(cellValue === 2) {
        return "自营库存";
      } else if(cellValue === -1) {
        return "mouser";
      } else if(cellValue === -2) {
        return "arrow";
      } else if(cellValue === 11) {
        return "圣禾堂";
      } else if(cellValue === 3) {
        return "立创商城";
      } else if(cellValue === 7) {
        return "华秋";
      } else if(cellValue === 9) {
        return "油柑网";
      } else if(cellValue === -3) {
        return "TTI";
      } else if(cellValue === -4) {
        return "Verical";
      } else if(cellValue === -5) {
        return "elementas";
      } else if(cellValue === -6) {
        return "avnetUs";
      } else if(cellValue === -7) {
        return "chip1stop";
      } else if(cellValue === -8) {
        return "future";
      } else if(cellValue === -9) {
        return "element14_uk";
      } else if(cellValue === -10) {
        return "onlinecomponents";
      } else if(cellValue === -11) {
        return "rscomponents";
      } else{
        return "其他";
      }
    },
    formatPay: function(row, column, cellValue) {
      if (cellValue === 1) {
        return "微信";
      } else if (cellValue === 2) {
        return "支付宝";
      } else if (cellValue === 3) {
        return "对公付款";
      }
    },
    formatPayType: function(row, column, cellValue) {
      if (cellValue === 1) {
        return "付款";
      } else if (cellValue === 2) {
        return "附加费";
      } else if (cellValue === 3) {
        return "优惠退还";
      } else if (cellValue === 4) {
        return "取消";
      }
    },
    formatPayStatus: function(row, column, cellValue) {
      if (cellValue === 1) {
        return "未付款";
      } else if (cellValue === 2) {
        return "已付款";
      } else if (cellValue === 3) {
        return "失败";
      } else if (cellValue === 4) {
        return "部分付款";
      }
    },
    formatAddress: function(row, column, cellValue) {
      if(cellValue) {
        return cellValue.province + ' ' + cellValue.city + ' ' + cellValue.area + ' ' + cellValue.addressDetail;
      }
    },
    formatStatus: function(row, column, cellValue) {
      if (cellValue === 2) {
        return "待审核";
      }else if (cellValue === 1) {
        return "待付款";
      }else if (cellValue === 3) {
        return "待发货";
      }else if (cellValue === 4) {
        return "已发货";
      }
    },
    formatMobile: function(row, column, cellValue) {
      if (cellValue) {
        return cellValue.mobile;
      }
    },
    getHistoryOrderData: function() {
      this.optionItem = this.common.extend(this.historyOrder, this.hisPagination);
      // 初始化默认加载菜单
      this.http.post('/order/history/list',
        this.optionItem,
        res => {
          if (res.success) {
            // 返回正确的处理
            this.historyData = res.datas.data;
            this.hisPagination.pageSize = res.datas.page.pageSize
            this.hisPagination.pageNum = res.datas.page.pageNum
            this.hisPagination.pageTotal = res.datas.page.pageCount
          } else {
            // 返回错误的处理
            this.$message.error(res.message)
          }
        }
      );
    },
    getOrderData: function() {
      this.optionItem = this.common.extend(this.order, this.pagination);
      // 初始化默认加载菜单
      this.http.post(
        '/order/list',
        this.optionItem,
        res => {
          if (res.success) {
            // 返回正确的处理
            this.data = res.datas.data
            this.pagination.pageSize = res.datas.page.pageSize
            this.pagination.pageNum = res.datas.page.pageNum
            this.pagination.pageTotal = res.datas.page.pageCount
          } else {
            // 返回错误的处理
            this.$message.error(res.message)
          }
        }
      );
    },
    onSubmit: function() {
      this.getOrderData()
    },
    queryHistoryPagination: function(currPage) {
      this.hisPagination.pageNum = currPage
      this.getHistoryOrderData()
    },
    queryPagination: function(currPage) {
      this.pagination.pageNum = currPage
      this.getOrderData()
    },
    handleSubRemarkEdit: function(row) {
      if (this.cellRemark.remark.sub != row.remark) {
        this.http.post(
          '/order/detail/remark/subset',
          {
            orderNo: row.orderNo,
            remark: this.cellRemark.remark.sub,
            token: this.user.getToken()
          }, res => {
            if (res.success) {
              row.remark = this.cellRemark.remark.sub
              this.cellRemark.tabSubIndex = null
              this.cellRemark.tabSubLabel = '' 
              this.cellRemark.remark.sub = ''
              // 返回正确的处理
              // this.getOrderData();
            } else {
              // 返回错误的处理
              this.$message.error(res.message)
            }
        });
      }else {
        this.cellRemark.tabSubIndex = null
        this.cellRemark.tabSubLabel = '' 
        this.cellRemark.remark.sub = ''
      }
    },
    cancelOrder: function(row) {
      this.http.post('/order/cancel', 
        {
          orderNo: row.orderNo,
          token: this.user.getToken()
        }, res => {
          if (res.success) {
            // 返回正确的处理
            this.getOrderData();
          } else {
            // 返回错误的处理
            this.$message.error(res.message)
          }
      });
    },
    confirmOrder: function(row) {
      console.log("aaa:"+JSON.stringify(row))
      if (row.discountedAmount > 0) {
        this.http.post(
        '/order/comfirm', 
        {
          orderNo: row.orderNo,
          token: this.user.getToken()
        }, res => {
          if (res.success) {
            // 返回正确的处理
            this.getOrderData();
          } else {
            // 返回错误的处理
            this.$message.error(res.message)
          }
        });
      }else {
        this.$message.error('商品价格必须大于0')
      }
    },
    removeInvoiceRecord: function(row) {
      this.http.post('/order/invoice/remove', 
        {
          orderNo: row.orderNo,
          token: this.user.getToken()
        }, res => {
          if (res.success) {
            // 返回正确的处理
            this.getOrderData();
          } else {
            // 返回错误的处理
            this.$message.error(res.message)
          }
      });
    },
    bestSendGoods: function(row) { // 未付款先发货
      this.http.post('/order/approve', 
        {
          orderNo: row.orderNo,
          token: this.user.getToken()
        }, res => {
          if (res.success) {
            // 返回正确的处理
            this.getOrderData();
          } else {
            // 返回错误的处理
            this.$message.error(res.message)
          }
      });
    },
    handleRemarkEdit: function(row) {
      if (this.cellRemark.remark.main != row.remark) {
        this.http.post(
          '/order/remark/set',
          {
            orderNo: row.orderNo,
            remark: this.cellRemark.remark.main,
            token: this.user.getToken()
          }, res => {
            if (res.success) {
              this.cellRemark.tabMainIndex = null
              this.cellRemark.tabMainLabel = '' 
              this.cellRemark.remark.main = '' 
              // 返回正确的处理
              this.getOrderData();
            } else {
              // 返回错误的处理
              this.$message.error(res.message)
            }
          });
      }else {
        this.cellRemark.tabMainIndex = null
        this.cellRemark.tabClickLabel = '' 
        this.cellRemark.remark.main = row.remark
      }
    },
    handleSubCostEdit: function(row) {
      if (this.cellCost.price < 0) {
        this.$message.error('成本必须大于0')
        return
      }
      if (this.cellCost.price != row.costPrice) {
        this.http.post(
          '/order/detail/set/costprice', 
          {
            orderNo: row.orderNo,
            costPrice: this.cellCost.price,
            token: this.user.getToken()
          }, res => {
            if (res.success) {
              row.costPrice = this.cellCost.price
              this.cellCost.tabCostIndex = null
              this.cellCost.tabCostLabel = '' 
              this.cellCost.price = ''
              // 返回正确的处理
              // this.getOrderData();
            } else {
              // 返回错误的处理
              this.$message.error(res.message)
            }
        });
      }else {
        this.cellCost.tabCostIndex = null
        this.cellCost.tabCostLabel = '' 
        this.cellCost.price = ''
      }
    },
    onSubmitAddress: function(row) {
      this.addressForm.orderNo = row.orderNo
      this.addressForm.receiveAddress = row.receiveAddress
      this.addressForm.receiveUser = row.receiveUser
      this.addressForm.receiveMobile = row.receiveMobile
      this.addressForm.userRemark = row.userRemark
      
      this.http.post('/order/address/modify', this.addressForm, res => {
          if (res.success) {
            // 返回正确的处理
            this.getOrderData();
          } else {
            // 返回错误的处理
            this.$message.error(res.message)
          }
      });
    },
    addNewOrder: function(row) {
      this.http.post(
      '/order/addNewOrder',
      {
        orderNo: row.orderNo,
        token: this.user.getToken()
      }, res => {
        if (res.success) {
          // 返回正确的处理
          this.getOrderData();
        } else {
          // 返回错误的处理
          this.$message.error(res.message)
        }
      });
    },
    handleShowInvoices: function(list) {
      this.isInvoiceShow = true
      console.log(JSON.stringify(list))
      this.invoiceList = list
    }
  },
  mounted: function() {
    this.getOrderData();
  },
};
</script>


<style>
.invoice-css {
  padding: 10px 0 20px 0; width: 60%; text-align:center;
}
.el-table th {
  background: #F5F7FA;
}
.el-table__expanded-cell {  
  padding: 0px 0px 15px 47px !important;
}
.el-tabs {
  border:1px solid #eee;
}
.el-tabs__nav {
  padding: 0 20px;
}
.el-tabs__active-bar {
  margin-left: 20px;
}
.el-input--suffix .el-input__inner {
  padding-right: 16px;
}

.demo-table-expand {
  font-size: 0;
}
.el-form-item__content {
  line-height: none;
}
.del_line::after {
	content: no-open-quote;
	position: absolute;
	margin-top: 24px;
	left: 60px;
	width: 75%;
	border-bottom: 1px solid #ccc;
}
.del_refund_line::after {
	content: no-open-quote;
	position: absolute;
	margin-top: 24px;
	left: 60px;
	width: 75%;
	border-bottom: 1px dashed #F56C6C;
}
.el-table .efficacy-row {
  color: #ccc !important;
}
.el-table .warning-row {
  background: #eee;
}
.el-table .nofollow-row {
  background: #F2F6FC;
}
.el-table .danger-row {
  background: #F56C6C;
}
.el-table .transparent-row {
  background: #F2F6FC;
}
.el-table .processing-row {
  background:rgb(254, 240, 240);
}
.el-table .remind-row {
  background: rgb(253, 246, 236) !important;
}
.el-table .success-row {
  background: #f0f9eb !important;
}
.el-table .success-refund{
  background: #f5f7fa !important;
}
.el-table .success-paid{
  background:#fff !important;
}
.el-table .success-over {
  background: #ecf5ff !important;
}
.el-table .cell {
  line-height: 24px !important;
}
.el-button+.el-button {
    margin-left: 0px !important;
}
.el-table .hover-row>td {
  background: Transparent !important;
}
.demo-table-expand label {
  width: 90px;
  color: #99a9bf;
}
.demo-table-expand .el-form-item {
  margin-right: 0;
  margin-bottom: 0 !important;
  padding: 0 40px;
  width: 50%;
}
.el-form-item__content {
  line-height: none;
}
.invoiceCss {
  padding: 0 40px;
}
</style>


// WEBPACK FOOTER //
// src/components/views/order/orderAllList.vue